"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchParentMetric = exports.getRecordsSuggestions = exports.typeaheadSearch = exports.getInvoicingEntities = exports.deleteParentAccount = exports.checkUniqueCode = exports.checkUniqueName = exports.getClients = exports.update = exports.create = exports.get = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var base = '/api/parent-account';
function get(parentAccountId) {
    return api_1.default.get("".concat(base, "/").concat(parentAccountId, "&bare")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.get = get;
function create(parentAccountFormData) {
    var parentAccountData = parentAccountFormData;
    return api_1.default.post(base, parentAccountData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function update(oldParentAccountData, parentAccountFormData) {
    var parentAccountData = parentAccountFormData;
    return api_1.default
        .put(base + '/' + oldParentAccountData.id, parentAccountData)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.update = update;
/**
 * Gets client users for the passed parent account ID
 *
 * @param {Number} parentAccountId
 * @param {object} options
 * @param { number|null } options.limit enable overriding the limit with a number or null (to remove the limit)
 */
function getClients(parentAccountId, options) {
    if (options === void 0) { options = null; }
    var limit = 20;
    if (options.limit !== undefined) {
        limit = options.limit;
    }
    var url = limit ? "".concat(base, "/").concat(parentAccountId, "/clients?limit=").concat(limit) : "".concat(base, "/").concat(parentAccountId, "/clients");
    return api_1.default.get(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getClients = getClients;
function checkUniqueName(parentAccountName, parentAccountId) {
    var url = base + "/check-unique-name?value=".concat(parentAccountName);
    if (parentAccountId) {
        url = "".concat(url, "&id=").concat(parentAccountId);
    }
    return api_1.default.get(url).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.checkUniqueName = checkUniqueName;
function checkUniqueCode(parentAccountCode) {
    return api_1.default
        .get(base + "/check-unique-code?value=".concat(parentAccountCode))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.checkUniqueCode = checkUniqueCode;
function deleteParentAccount(parentAccountId) {
    return api_1.default.delete("".concat(base, "/").concat(parentAccountId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.deleteParentAccount = deleteParentAccount;
function getInvoicingEntities(parentAccountId, accountId) {
    var query = accountId ? "?accountId=".concat(accountId) : '';
    return api_1.default
        .get("/api/invoicing-entity/parent-account/".concat(parentAccountId).concat(query))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getInvoicingEntities = getInvoicingEntities;
function typeaheadSearch(query) {
    return api_1.default
        .get("".concat(base, "/typeahead-search?q=").concat(encodeURIComponent(query)))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.typeaheadSearch = typeaheadSearch;
function getRecordsSuggestions(query, recordTypes) {
    var queryParams = query_string_1.default.stringify({
        q: query,
        recordType: recordTypes,
    });
    return api_1.default.get("".concat(base, "/autocomplete-records?").concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getRecordsSuggestions = getRecordsSuggestions;
function fetchParentMetric(_a) {
    var id = _a.id, month = _a.month, type = _a.type;
    if (!['office', 'account'].includes(type)) {
        throw new Error('type needs to be eather office or account');
    }
    var monthStr = month ? "?month=".concat(month) : '';
    return api_1.default.get("/api/report/".concat(type, "-metric/").concat(id).concat(monthStr)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.fetchParentMetric = fetchParentMetric;
var api = {
    get: get,
    create: create,
    update: update,
    getClients: getClients,
    checkUniqueName: checkUniqueName,
    checkUniqueCode: checkUniqueCode,
    deleteParentAccount: deleteParentAccount,
    getInvoicingEntities: getInvoicingEntities,
    typeaheadSearch: typeaheadSearch,
    getRecordsSuggestions: getRecordsSuggestions,
    fetchParentMetric: fetchParentMetric,
};
exports.default = api;
